import script from "./ResumeWorkExperiences.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResumeWorkExperiences.vue?vue&type=script&setup=true&lang=ts"

import "./ResumeWorkExperiences.vue?vue&type=style&index=0&id=755bac10&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-755bac10"]])

export default __exports__